<template>
  <transition name="muted">
    <li class="comment muted">
      <edi-mute-icon @click="unmuteUser({ userNick, userId })"/>
      <div class="comment-wrapper">
        <div class="comment-header">
          <div class="author-info">
            <div class="header-title">
              <span class="num">#{{ num }}</span>
              <a @click.stop :href="userProfile(userProfileUrl)" class="author-name">{{ userNick }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="mute">
        <p class="mute-text">Has silenciado a este usuario</p>
        <a class="mute-link" @click.stop="unmuteUser({userId, userNick })">Restablecer</a>
      </div>
    </li>
  </transition>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import EdiMuteIcon from '../../../components/EdiMuteIcon';

  export default {
    name: 'edi-muted-comment-list-item',
    components: {
      EdiMuteIcon
    },
    props: {
      num: Number,
      userNick: String,
      userId: Number,
      userProfileUrl: String,
    },
    computed: {
      ...mapGetters([
        'userProfile'
      ])
    },
    methods: {
      ...mapActions([
        'unmuteUser'
      ])
    }
  }
</script>

<style scoped>
  .muted-enter-active {
    transition: opacity .15s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .muted-enter {
    opacity: 0;
  }
</style>
